import { ChangeDetectorRef, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AgentConfig } from '../../../../lib/interfaces/aitypes';
import { GenericStepConfig, GenericStream, StreamClosingResult, StreamClosingType } from '../../../../lib/interfaces/generic-streams';
import { AppdataService } from '../../../../service/appdata.service';
import { GenericStreamsService } from '../../../../service/generic-streams.service';
import { AddGenericStreamComponent } from '../add-generic-stream/add-generic-stream.component';
import { AddConfigComponent } from './add-config/add-config.component';
import { AddSreamResultComponent } from './add-sream-result/add-sream-result.component';
import { SelectConfigComponent } from './select-config/select-config.component';

@Component({
    selector: 'app-generic-stream-view',
    standalone: false,
    templateUrl: './generic-stream-view.component.html',
    styleUrl: './generic-stream-view.component.scss'
})
export class GenericStreamViewComponent implements OnInit, OnDestroy {
    streamService = inject(GenericStreamsService);
    dataService = inject(AppdataService);
    route = inject(ActivatedRoute);
    dialog = inject(MatDialog);
    cd = inject(ChangeDetectorRef)
    router = inject(Router);

    agentList: AgentConfig[] = []
    closingStreamTypes: StreamClosingType[] = [];
    stream: GenericStream | undefined;
    isLoading: boolean = false;
    editActive: boolean = false;
    myTimeOut: any;
    myClearTimeOut: any;
    checkEditTimoutId: any;

    destroyRef = inject(DestroyRef);


    activeStep: GenericStepConfig | undefined;
    activeStepNumber: number | undefined;

    editKeyQuestion = -1;
    editKeyQuestionTitle: FormControl = new FormControl();
    editKeyQuestionQ: FormControl = new FormControl();
    editKeyQuestionDetails: FormControl = new FormControl();
    keyQuestionDetailsEdit = "";

    websearchObject = {
        title: "",
        query: "",
        source: "",
        description: ""
    }

    webSearchSources: { id: string, name: string, description: string }[] = [
        { id: "IAI_ISTARI_AI", name: "istari.ai", description: "AI-powered search engine" },
        { id: "OWS_OPEN_WEB_SEARCH", name: "Open Web Search", description: "" },
    ];
    ngOnDestroy(): void {
        this.streamService.deleteEdittingModeForStream(this.stream?.id!);
        this.myClearTimeOut(this.checkEditTimoutId);
    }

    async ngOnInit() {
        this.myTimeOut = window.setTimeout;
        this.myClearTimeOut = window.clearTimeout;
        let urlParamsId = this.route.snapshot.paramMap.get('id');
        if (urlParamsId) {
            let s = await this.streamService.getOneGenericStream(urlParamsId);
            if (s === false) return;
            this.stream = s;
            this.activeStep = this.stream.steps?.[0];
            this.activeStepNumber = 1
            this.stream.globalStream = Boolean(this.stream.globalStream);
            // console.log('Fetched stream:', s);

            this.isLoading = true;
            let result = await this.streamService.checkAndSetEdittingModeForStream(urlParamsId);
            this.isLoading = false;
            if (result !== true) {
                alert(`The Stream will be currently in editing by:\n\n${result.userName}`);
                this.router.navigate(['/home', 'streams']);
            }
            this.regularsetedittingMode()
        }
        this.dataService.agents.asObservable().subscribe(agents => {
            this.agentList = agents;
        });
        this.closingStreamTypes = this.dataService.streamClosingTypes;

        // console.log(this.stream);



    }
    cancelStream() {
        this.streamService.deleteEdittingModeForStream(this.stream?.id!);
        this.router.navigate(['/home', 'streams']);
    }
    addStreamResult() {
        let dia = this.dialog.open(AddSreamResultComponent, {
            data: {
                title: "New Stream Result",
                edit: false,
                value: null,
                closingStreamTypes: this.closingStreamTypes
            },
            autoFocus: false,
            panelClass: "small-dialog"
        });
        dia.afterClosed().subscribe(async (newTitle: Partial<StreamClosingResult>) => {
            if (newTitle && this.stream) {
                if (!this.stream.streamResults) {
                    this.stream.streamResults = [];
                }
                this.stream.streamResults.push({
                    orderNumber: this.stream.streamResults.length + 1,
                    title: newTitle.title!,
                    type: newTitle.type!
                });
            }
        });
    }
    deleteStreamResult(result: StreamClosingResult) {
        let i = confirm("Do you really want to delete this Stream Result?");
        if (!i) return;
        this.stream!.streamResults = this.stream!.streamResults.filter(r => r !== result);

    }
    editStreamResult(result: StreamClosingResult) {
        let dia = this.dialog.open(AddSreamResultComponent, {
            data: {
                title: "Edit Stream Result",
                edit: true,
                value: result,
                closingStreamTypes: this.closingStreamTypes
            },
            autoFocus: false,
            panelClass: "small-dialog"
        });
        dia.afterClosed().subscribe(async (newTitle: Partial<StreamClosingResult>) => {
            if (newTitle) {
                result.title = newTitle.title!;
                result.type = newTitle.type!;
            }
        });
    }
    regularsetedittingMode() {
        this.checkEditTimoutId = this.myTimeOut(() => {
            this.streamService.checkAndSetEdittingModeForStream(this.stream?.id!);
            this.regularsetedittingMode();
        }, 10000);

    }
    editMetaData() {
        let dia = this.dialog.open(AddGenericStreamComponent, {
            autoFocus: false,
            data: this.stream
        });
        dia.afterClosed().subscribe(result => {
            if (result) {
                this.stream!.name = result.name;
                this.stream!.description = result.description;
                this.stream!.categoryId = result.categoryId;
                this.stream!.status = result.status;
                this.stream!.type = result.type;
                this.stream!.llmId = result.llmId;
                this.stream!.streamGoal = result.streamGoal;
                this.stream!.globalStream = result.globalStream;
                this.stream!.promotionArea = result.promotionArea;
                this.saveStream();

            }
        });
    }
    addWebQuestion() {
        if (!Array.isArray(this.activeStep?.websearch)) {
            this.activeStep!.websearch = [];
        }
        this.activeStep?.websearch?.push({ ...this.websearchObject });
        this.websearchObject = { title: '', source: '', query: '', description: '' };
    }
    addKeyQuestion(title: string, question: string, description: string) {
        if (question === '') return;
        this.activeStep?.keyQuestions.push({ title, question, description });
    }
    removeWebQuestion(index: number) {
        this.activeStep?.websearch?.splice(index, 1);
    }
    removeKeyQuestion(index: number) {
        this.activeStep?.keyQuestions.splice(index, 1);
    }
    checkboxChange() {
        if (!this.activeStep) return;
        if (this.activeStep.websearchStatus === false) {
            this.activeStep.websearch = []

        }
        if (this.activeStep.uploadStatus === false) {
            this.activeStep.upload = {
                resultPrompt: "",
            }
        }
    }

    deleteStep(index: number) {
        let i = confirm("Do you really want to delete this Step? All changes will be revoked of this step!")
        if (!i) return;
        if (this.stream?.steps?.[index] === this.activeStep) {
            this.activeStep = undefined;
        }

        this.stream?.steps?.splice(index, 1);
        this.cd.detectChanges();

    }
    selectConfig() {
        let dia = this.dialog.open(SelectConfigComponent, {
            panelClass: "wide-dialog",
            autoFocus: false
        });
        dia.afterClosed().subscribe(async result => {
            if (result) {

                let c = await this.streamService.getGenericConfigById(result);
                if (c === false) return;

                this.stream?.steps?.push(c);
            }
        });

    }
    addConfig() {
        let dia = this.dialog.open(AddConfigComponent, {
            panelClass: "wide-dialog",
            autoFocus: false,
            restoreFocus: false,
            disableClose: true,
        });
        dia.keydownEvents().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (event) => {
                if(event.key === 'Escape') {
                    dia.close();
                }
            }
        })

        dia.afterClosed().subscribe(result => {
            if (result) {
                // result.id = new Date().getTime().toString();
                this.stream?.steps?.push(result);
            }
        });
    }
    async setStepForEdit(step: GenericStepConfig, i: number) {
        this.editActive = false;
        this.activeStep = step;
        this.activeStepNumber = i + 1;
        this.cd.detectChanges();
    }
    async switchStepOrder(from: number, to: number) {
        await this.stream?.steps?.splice(to, 0, this.stream?.steps?.splice(from, 1)[0]);
        if (this.activeStepNumber === from + 1) {
            this.activeStepNumber = to + 1;
        }
        this.cd.detectChanges();
    }
    async saveStream() {
        if (!this.stream) return;

        for (let step of this.stream.steps || []) {
            if (!step.closingPromptId || step.closingPromptId === "") {
                step.closingPromptId = "CLS_PDF_DEFAULT";
            }
        }

        // durch alle Steps gehen und wenn websearchStatus || uploadStatus === false die jeweiligen Objecte zurück setzen!
        this.isLoading = true
        let update = await this.streamService.updateGenericStream(this.stream);
        this.isLoading = false;
        if (update === false) return;
    }

    toggleKeyQuestionEdit(i: number, q: any) {
        if (this.editKeyQuestion !== i) {
            this.editKeyQuestion = i;
            console.log(q)
            this.editKeyQuestionTitle?.setValue(q.title);
            this.editKeyQuestionQ?.setValue(q.question);
            this.editKeyQuestionDetails?.setValue(q.description);
        } else {
            this.editKeyQuestion = -1;
        }
    }

    onKeyQuestionDetailsChange($event: any) {
        if (typeof $event == "string") {
            this.keyQuestionDetailsEdit = $event;
        }
    }

    saveKeyQuestionEdit(i: number) {
        if (this.activeStep) {
            this.activeStep.keyQuestions[i].title = this.editKeyQuestionTitle.value;
            this.activeStep.keyQuestions[i].question = this.editKeyQuestionQ.value;
            this.activeStep.keyQuestions[i].description = this.keyQuestionDetailsEdit;
            this.toggleKeyQuestionEdit(i, {});
        }
    }

    changeQuestionOrder(previousIndex: number, currentIndex: number): void {
        if (this.activeStep?.keyQuestions) {
            this.editKeyQuestion = -1;
            const questions = this.activeStep.keyQuestions;
            const [question] = questions.splice(previousIndex, 1);
            questions.splice(currentIndex, 0, question);
        }
    }
}
